/* this file is transformed by vux-loader */
/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
import plugins from './plugins/plugins';

// 全局通用
import globalStore from './modules/globalStore';
// import selectData from './modules/selectData'
Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    // 全局
    // selectData,
    globalStore: globalStore
  },
  plugins: plugins,
  scrict: process.env.NODE_ENV !== 'production'
});